export enum InfluencesKeys {
  SourceCampaignId = 'sourceCampaignId',
  SourceCampaignGroup = 'sourceCampaignGroup',
  InfluencedCampaignId = 'influencedCampaignId',
  InfluencedCampaignGroup = 'influencedCampaignGroup',
  LastCampaignId = 'lastCampaignId',
  LastCampaignGroup = 'lastCampaignGroup',
}
